import React from 'react'
import Loading from '../Loading'
import jobRepo from '../../requests/jobs'
import { Chart } from 'react-google-charts'
import WidgetHeader from './WidgetHeader'
import moment from 'moment'

export default class JobByTimeAndStatus extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      loading: false,
      options: {
        // title: 'Box Office Earnings in First Two Weeks of Opening',
        // subtitle: 'in millions of dollars (USD)',
        // hAxis: { title: 'Age', minValue: 0, maxValue: 15 },
        // vAxis: { title: 'Weight', minValue: 0, maxValue: 15 },
        chartArea: {left:20,top:10,width:'100%',height:'80%'},
        legend: 'none',
      },
      rows:
      [
        ['Account', 'Done', 'Error', 'Running'],
        ['None', 0, 0, 0]
        // ['2015', 1170, 460, 250],
        // ['2016', 660, 1120, 300],
        // ['2017', 1030, 540, 350]
      ],
      // [
      //   ['Element', 'Density', { role: 'style' }],
      //   ['Copper', 8.94, '#b87333'],            // RGB value
      //   ['Silver', 10.49, 'silver'],            // English color name
      //   ['Gold', 19.30, 'gold'],
      //   ['Platinum', 21.45, 'color: #e5e4e2' ], // CSS-style declaration
      // ],
      time: moment().format('YYYY-MM-DD')
    }
  }
  componentWillMount () {
    if(!this.props.time || !this.state.time){
      this.setState({time: moment().format('YYYY-MM-DD')})
    }
    this.loadData()
  }
  loadData() {
    // this.setState({loading: true})
    jobRepo.getJobCounterByStatusGroupByAccounts(this.state.time).then(data => {
      console.log(data)
      let rows = [['Account', 'Done', 'Error', 'Running']].concat(data)
      this.setState({ rows:rows, loading: false})
    })
  }
  async onTimeChange(time){
    await this.setState({time})
    this.loadData()
  }
  render(){
    if(this.state.loading === true){
      return(<Loading/>)
    }
    const time_opt = [
      { value: '12', label: 'Last 12 Hours' },
      { value: '24', label: 'Last 24 Hours' },
      { value: `${2 * 24}`, label: 'Last 2 Days' },
      { value: `${5 * 24}`, label: 'Last 5 Days' },
      { value: `${7 * 24}`, label: 'Last Week' }
    ]
    return(
      <div>
      <WidgetHeader title = 'By Accounts' options = {time_opt} time = {this.state.time} onChange={(time) =>{this.onTimeChange(time)}}/>
      <div className={'col-md-12'}>
        <Chart
          chartType="ColumnChart"
          data={this.state.rows}
          options={this.state.options}
          graph_id="ColumnChart-JobByAccounts"
          width={'100%'}
          height={'300px'}
          legend_toggle
        />
      </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/JobByAccount.js